import React from "react";
import { formatRange } from "../../pages/vacationDates";
import Avatar from "./Avatar";

const STATUS_TITLES = { active: "Активна", planned: "Запланирована", past: "Прошла" };

function ChipIcon({ children }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

export default function SubstitutionChip({ sub, onEdit, onDelete }) {
  return (
    <span className={`vs-chip vs-chip--${sub.status}`} title={STATUS_TITLES[sub.status]}>
      <Avatar name={sub.substitute_name} size={18} />
      <span className="vs-chip__text">{`${sub.substitute_name} · ${formatRange(sub.start_date, sub.end_date)}`}</span>
      {sub.comment ? (
        <span className="vs-chip__note" role="img" title={sub.comment} aria-label={`Комментарий: ${sub.comment}`}>
          <ChipIcon>
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </ChipIcon>
        </span>
      ) : null}
      <button
        type="button"
        className="vs-chip__btn"
        aria-label={`Изменить замену ${sub.substitute_name}`}
        onClick={onEdit}
      >
        <ChipIcon>
          <path d="M12 20h9" />
          <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
        </ChipIcon>
      </button>
      <button
        type="button"
        className="vs-chip__btn"
        aria-label={`Удалить замену ${sub.substitute_name}`}
        onClick={onDelete}
      >
        <ChipIcon>
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </ChipIcon>
      </button>
    </span>
  );
}
